import React from "react";
import ReactDOM from "react-dom";

import "./styling/Backdrop.css";

const Backdrop = React.forwardRef((props, ref) => {
  return ReactDOM.createPortal(
    <div
      ref={ref}
      className={` ${props.error ? "backdrop-error" : "backdrop"}`}
      onClick={props.onClick}
    ></div>,
    document.getElementById("backdrop-hook")
  );
});

export default Backdrop;
